import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FabricColorService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  public manageFabricColor(fabric, isEdit, id = null) {
    if (isEdit) {
      return this.http.put(environment.apiUrl + '/backoffice/fabric-colors/' + id, fabric)
        .pipe(catchError(res => this.helper.catchError(res)));
    }
    return this.http.post(environment.apiUrl + '/backoffice/fabric-colors/', fabric)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  softDeleteFabricColor(id) {
    return this.http.delete(environment.apiUrl + '/backoffice/fabric-colors/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  softReAddFabricColor(id) {
    return this.http.put(environment.apiUrl + '/backoffice/fabric-colors/' + id + '/re-add', {})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  removeImage(fileId, fabricId) {
    return this.http.delete(environment.apiUrl + '/backoffice/fabric-colors/' + fabricId + '/remove-image/' + fileId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }
}
